import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { createIntersectionObserver } from './LazyImage.utils';
import { defaultBlurRadius, BlurredImage } from './BlurredImage';
import { imageStyle } from '../image.utils';
import { EagerImage } from '../eagerImage/EagerImage';
import { CalculatedThumbnail, imageStyleSheet } from '../image.types';

export const statusLabels = {
  initial: 'initial',
  ready: 'ready',
};

interface LazyImageState {
  status: string,
}

const lazyImageStyle = StyleSheet.create({
  style: {
    willChange: 'opacity, transform',
  },
  initial: {
    opacity: 0,
  },
  ready: {
    opacity: 1,
  },
}) as imageStyleSheet;

export class LazyImageComponent extends React.Component<CalculatedThumbnail, LazyImageState> {
  observer: any = null;

  blurRef: React.RefObject<HTMLCanvasElement>;

  imageRef: React.RefObject<HTMLImageElement>;

  constructor(props: CalculatedThumbnail) {
    super(props);

    this.imageRef = React.createRef();
    this.blurRef = React.createRef();
    this.state = {
      status: statusLabels.initial,
    };
  }

  componentWillUnmount() {
    this.observer = this.stopObservingIntersections();
  }


  getImageStyle() {
    const { status } = this.state;
    return css(imageStyle.base, lazyImageStyle[status], lazyImageStyle.style);
  }

  getBlurRadius() {
    return defaultBlurRadius;
  }

  getBlurredImageRef = (ref: React.RefObject<HTMLCanvasElement>) => {
    this.blurRef = ref;
    this.observer = this.createIntersectionObserver();
  };

  intersectionCallback = (entries: any[]) => entries
    .filter(entry => entry.intersectionRatio > 0)
    .forEach(() => this.loadImage());


  createIntersectionObserver() {
    return createIntersectionObserver(
      this.intersectionCallback,
      this.blurRef.current,
    );
  }

  stopObservingIntersections() {
    if (this.observer && this.blurRef.current) {
      this.observer.unobserve(this.blurRef.current);
    }
  }

  loadImage() {
    const { srcSet, imageUrl } = this.props;
    const img: any = this.imageRef.current;
    img.onload = () => this.setState({ status: statusLabels.ready });
    this.stopObservingIntersections();

    img.srcset = srcSet;
    img.src = imageUrl;
  }

  render() {
    const { status } = this.state;
    const { sizes, alt, title, lowResUrl } = this.props;
    return (
      <React.Fragment>
        <BlurredImage src={lowResUrl} blur={this.getBlurRadius()} getRefCallback={this.getBlurredImageRef} status={status} />
        <img
          className={this.getImageStyle()}
          ref={this.imageRef}
          alt={alt}
          title={title}
          sizes={sizes}
        />
        <noscript>
          <EagerImage {...this.props} />
        </noscript>
      </React.Fragment>
    );
  }
}

export const LazyImage = LazyImageComponent;
